import MarkdownLink from './MarkdownLink';

export default MarkdownLink;
